module.exports = __webpack_public_path__ + "static/media/community-no-uploads-document.91fc2705.svg";